export const countries = [
  { name: 'ایران', nameEn: 'Iran', code: 'IR', dialCode: '98', flag: '🇮🇷', placeholder: '09123456789', maxLength: 11 },
  { name: 'افغانستان', nameEn: 'Afghanistan', code: 'AF', dialCode: '93', flag: '🇦🇫', placeholder: '701234567', maxLength: 9 },
  { name: 'امارات متحده عربی', nameEn: 'UAE', code: 'AE', dialCode: '971', flag: '🇦🇪', placeholder: '501234567', maxLength: 9 },
  { name: 'عربستان سعودی', nameEn: 'Saudi Arabia', code: 'SA', dialCode: '966', flag: '🇸🇦', placeholder: '501234567', maxLength: 9 },
  { name: 'ترکیه', nameEn: 'Turkey', code: 'TR', dialCode: '90', flag: '🇹🇷', placeholder: '5012345678', maxLength: 10 },
  { name: 'عراق', nameEn: 'Iraq', code: 'IQ', dialCode: '964', flag: '🇮🇶', placeholder: '7012345678', maxLength: 10 },
  { name: 'پاکستان', nameEn: 'Pakistan', code: 'PK', dialCode: '92', flag: '🇵🇰', placeholder: '3012345678', maxLength: 10 },
  { name: 'هند', nameEn: 'India', code: 'IN', dialCode: '91', flag: '🇮🇳', placeholder: '9876543210', maxLength: 10 },
  { name: 'قطر', nameEn: 'Qatar', code: 'QA', dialCode: '974', flag: '🇶🇦', placeholder: '30123456', maxLength: 8 },
  { name: 'کویت', nameEn: 'Kuwait', code: 'KW', dialCode: '965', flag: '🇰🇼', placeholder: '50123456', maxLength: 8 },
  { name: 'عمان', nameEn: 'Oman', code: 'OM', dialCode: '968', flag: '🇴🇲', placeholder: '92123456', maxLength: 8 },
  { name: 'بحرین', nameEn: 'Bahrain', code: 'BH', dialCode: '973', flag: '🇧🇭', placeholder: '36001234', maxLength: 8 },
  { name: 'چین', nameEn: 'China', code: 'CN', dialCode: '86', flag: '🇨🇳', placeholder: '13800138000', maxLength: 11 },
  { name: 'روسیه', nameEn: 'Russia', code: 'RU', dialCode: '7', flag: '🇷🇺', placeholder: '9123456789', maxLength: 10 },
  { name: 'آلمان', nameEn: 'Germany', code: 'DE', dialCode: '49', flag: '🇩🇪', placeholder: '15123456789', maxLength: 11 },
  { name: 'بریتانیا', nameEn: 'UK', code: 'GB', dialCode: '44', flag: '🇬🇧', placeholder: '7123456789', maxLength: 10 },
  { name: 'آمریکا', nameEn: 'USA', code: 'US', dialCode: '1', flag: '🇺🇸', placeholder: '2015550123', maxLength: 10 },
  { name: 'کانادا', nameEn: 'Canada', code: 'CA', dialCode: '1', flag: '🇨🇦', placeholder: '4165550123', maxLength: 10 },
]

export const defaultCountry = countries[0]

export function getCountryByCode(code) {
  return countries.find(c => c.code === code) || defaultCountry
}

export function getCountryByDialCode(dialCode) {
  return countries.find(c => c.dialCode === dialCode) || defaultCountry
}

export function isIran(dialCode) {
  return dialCode === '98'
}
